import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as Globals from '../../globals';
import { Observable, of } from 'rxjs';

import { LocalStorage } from '@ngx-pwa/local-storage';
import { PayloadService } from '../payload/payload.service';
import { tap, switchMap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class TtsService {

    constructor(
        private http: HttpClient,
        public localStorage: LocalStorage,
        public payloadService: PayloadService
    ) { }


    list(month, year, phone_type, status): Observable<any> {
        return this.payloadService.getPayload().pipe(
            switchMap(
                (payload) =>{
                    return this.http.post(Globals.url_api + "tts/list", {
                        "payload": payload,
                        "month" : month,
                        "year": year,
                        "phone_type" : phone_type,
                        "status" : status
                    });
                }
            )
        )
    }
}
